import { css } from "@emotion/css";

export const previewStyles = {
  previewContainer: css`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
  `,
  preview: css`
    padding: 16px;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
  `,
  empty: css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  `,
  questionCard: css`
    margin-top: 16px;
    padding: 20px;
    background: #e7f3ff;
    border-radius: 8px;
  `,
  questionTitle: css`
    font-size: 17px !important;
    font-weight: 700 !important;
    color: #333;
  `,
  questionDescription: css`
    font-size: 14px;
    color: #666;
    margin-bottom: 16px;
  `,
  semanticKeyBadge: css`
    font-size: 12px;
    color: #28a745;
    background: #d4edda;
    padding: 6px 10px;
    border-radius: 4px;
    margin-bottom: 12px;
    font-family: monospace;
    display: inline-block;
  `,
  selectContainer: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;
  `,
  radioOption: css`
    display: flex;
    align-items: center;
    padding: 8px;
    background: white;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
      background: #f8f9fa;
    }
  `,
  radioButton: css`
    padding: 0;
    margin-right: 12px;
  `,
  radioLabel: css`
    flex: 1;
    font-size: 15px;
    color: #495057;
    line-height: 1.5;
  `,
  otherField: css`
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #e9ecef;
  `,
  multiSelectContainer: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;
  `,
  subVariantsContainer: css`
    margin-left: 32px;
    display: flex;
    flex-direction: column;
    gap: 4px;
  `,
  groupSection: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  `,
  groupHeader: css`
    font-weight: 600 !important;
    font-size: 14px !important;
    margin-bottom: 8px !important;
    color: #333;
  `,
  checkboxOption: css`
    display: flex;
    align-items: center;
    padding: 8px;
    background: white;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
      background: #f8f9fa;
    }
  `,
  checkboxButton: css`
    padding: 0;
    margin-right: 12px;
  `,
  checkboxLabel: css`
    flex: 1;
    font-size: 15px;
    color: #495057;
    line-height: 1.5;
  `,
  booleanContainer: css`
    display: flex;
    flex-direction: row;
    gap: 8px;
    margin-top: 8px;
  `,
  booleanOption: css`
    display: flex;
    align-items: center;
    padding: 8px;
    background: white;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s;
    flex: 1;

    &:hover {
      background: #f8f9fa;
    }
  `,
  vasContainer: css`
    padding: 16px 0;
  `,
  vasLabels: css`
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    font-size: 14px;
    color: #666;
  `,
  integerContainer: css`
    padding: 8px 0;
    max-width: 200px;
  `,
  numberRangeBoxContainer: css`
    padding: 8px 0;
  `,
  numberRangeLabels: css`
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    font-size: 13px;
    color: #666;
  `,
  numberRangeBoxes: css`
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
  `,
  stars: css`
    display: flex;
    gap: 4px;
  `,
  star: css`
    border: none;
    background: none;
    cursor: pointer;
    font-size: 32px;
    color: #f5a623;
    padding: 0;
  `,
  numberRangeBox: css`
    width: 40px;
    height: 40px;
    border: 1px solid #ccc;
    border-radius: 6px;
    background: white;
    cursor: pointer;
    font-size: 15px;
    font-weight: 500;
    color: #495057;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s;

    &:hover {
      border-color: #2196f3;
      background: #e3f2fd;
    }
  `,
  numberRangeBoxSelected: css`
    && {
      background: #2196f3;
      color: white;
      border-color: #2196f3;
    }
  `,
  dateContainer: css`
    padding: 8px 0;
    max-width: 200px;
  `,
  textContainer: css`
    padding: 8px 0;
  `,
  questionnaireCard: css`
    margin-top: 16px;
    padding: 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #fafafa;
  `,
  groupCard: css`
    margin-top: 16px;
    padding: 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #fafafa;
  `,
  pageSection: css`
    margin-top: 16px;
    padding: 12px;
    background: white;
    border-radius: 4px;
  `,
  partItem: css`
    display: flex;
    align-items: center;
    padding: 8px;
    margin: 4px 0;
    background: #f5f5f5;
    border-radius: 4px;
  `,
  questionRefItem: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    margin: 4px 0;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
  `,
  questionInGroup: css`
    margin-bottom: 24px;
    padding: 20px;
    background: #e7f3ff;
    border-radius: 8px;
  `,
  questionNested: css`
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0;
    }
  `,
  questionHeader: css`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    flex-wrap: wrap;
  `,
  badgeContainer: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    margin-top: 12px;
  `,
  conditionalBadge: css`
    font-size: 12px;
    color: #0066cc;
    background: white;
    padding: 6px 10px;
    border-radius: 4px;
    margin-bottom: 12px;
    font-family: monospace;
  `,
  requiredBadge: css`
    font-size: 12px;
    color: #dc3545;
    background: #f8d7da;
    padding: 6px 10px;
    border-radius: 4px;
    font-weight: 500;
  `,
  conditionalRequiredBadge: css`
    font-size: 12px;
    color: #856404;
    background: #fff3cd;
    padding: 6px 10px;
    border-radius: 4px;
    font-family: monospace;
  `,
  groupDescription: css`
    font-size: 14px;
    color: #666;
    margin-bottom: 16px;
    padding: 12px;
    background: #f8f9fa;
    border-radius: 4px;
  `,
  questionGroupInQuestionnaire: css`
    margin-bottom: 24px;
    padding: 20px;
    background: #e7f3ff;
    border-radius: 8px;
  `,
  pageNav: css`
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
    padding: 12px 0;
    justify-content: center;
  `,
  pageNavButton: css`
    width: 40px;
    height: 40px;
    border: none;
    border-radius: 50%;
    background: #e0e0e0;
    color: #666;
    cursor: pointer;
    font-weight: bold;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;

    &:hover {
      background: #bbdefb;
    }
  `,
  pageNavButtonActive: css`
    && {
      background: #2196f3;
      color: white;
    }

    &&:hover {
      background: #1976d2;
    }
  `,
  pageTitle: css`
    color: #2196f3;
    margin-bottom: 12px !important;
    text-align: center;
  `,
  pageNavButtons: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
    padding-top: 16px;
    border-top: 1px solid #e0e0e0;
  `,
  navButton: css`
    padding: 8px 16px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    background: white;
    cursor: pointer;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &:hover:not(:disabled) {
      background: #f5f5f5;
    }
  `,
  pageIndicator: css`
    color: #666;
    font-size: 14px;
  `,
  questionnaireFooter: css`
    display: block;
    margin-top: 16px;
    padding: 12px;
    background: #f8f9fa;
    border-radius: 4px;
    color: #666;
  `,
  questionError: css`
    && {
      border: 2px solid #dc3545;
    }
  `,
  errorText: css`
    color: #dc3545;
    margin-top: 8px;
    display: block;
  `,
};
